import * as React from 'react'
import * as css from './HVACContent.module.css'
import CTALink from 'components/common/CTALink'
import Img from 'components/common/Img'
import SanityBlock from 'components/common/SanityBlock'
import clsx from 'clsx'

export default function HVACContent({ title, _rawContent, links, image }) {
	return (
		<section className="padding bg-suede-black text-white">
			<div className="ctnr grid items-center gap-8 md:grid-cols-2">
				<div className={clsx(css.txt, 'richtext')}>
					{title && <h2 className="h0">{title}</h2>}

					<SanityBlock body={_rawContent} />

					{!!links?.length && (
						<ol className="text-xl">
							{links?.map(({ title, seo }, key) => (
								<li key={key}>
									<CTALink
										url={seo.slug.current}
										className="with-icon hover:underline"
									>
										{title.split('Commercial HVAC ')[1]}
									</CTALink>
								</li>
							))}
						</ol>
					)}
				</div>

				<Img
					class="mx-auto max-w-[450px]"
					image={image.image}
					alt={image.alt || ''}
				/>
			</div>
		</section>
	)
}
